<!--<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">-->
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="stationAddLabel" i18n="@@CreateChargingStationHeader">Ladestation erstellen</h5>
      <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
    </div>

    <div class="modal-body">
      <app-mass-create-charging-station (newEntityEvent)="newEntityEvent($event)" [customerId]="customerId" [hideSubmit]="true"></app-mass-create-charging-station>
    </div>

    <div class="modal-footer">
      <a class="btn btn-yellow" id="cancel" data-bs-toggle="modal" role="button" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</a>
      <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
        <button type="submit" id="creat_chargestation" class="btn btn-primary" [disabled]="!formService.form.valid" i18n="@@CreateChargingStationButton">Ladestation erstellen</button>
      </form>
    </div>
  </div>
<!--</div>-->
